import subscriber from "@/http/requests/newsletter/subscriber"

export default {
  fetch({ commit }, queryData) {
    return new Promise((resolve, reject) => {
      subscriber.fetch(queryData).then(response => {
        commit('SET_SUBSCRIBERS', response.data.data.newsletterSubscribers)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  add({ commit }, data) {
    return new Promise((resolve, reject) => {
      subscriber.add(data).then(response => {
        commit('ADD_SUBSCRIBER', response.data.data.createNewsletterSubscriber)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  update({ commit }, data) {
    return new Promise((resolve, reject) => {
      subscriber.update(data).then(response => {
        commit('UPDATE_SUBSCRIBER', response.data.data.updateNewsletterSubscriber)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  delete({ commit }, subscriberId) {
    return new Promise((resolve, reject) => {
      subscriber.delete(subscriberId).then(response => {
        commit('DELETE_SUBSCRIBER', subscriberId)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  infos({ commit }, subscriberId) {
    return new Promise((resolve, reject) => {
      subscriber.infos(subscriberId).then(response => {
        commit('ADD_SUBSCRIBER_INFOS', response.data.data.newsletterSubscriberInfos)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  }
}
